import { supabase } from './api'

export const revalidate = 0

export async function getAllData() {
	const { data, error } = await supabase.from('scheduledays').select()

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function getIdData(id) {
	const { data, error } = await supabase.from('scheduledays').select().eq('id', id)
	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function getInstructorIdData(instructorId) {
	// console.log("scheduledays", instructorId);

	const { data, error } = await supabase
		.from('scheduledays')
		.select()
		//.or(`instructorId.eq.${instructorId},subinstructorId.eq.${instructorId}`);
		.eq('instructorId', instructorId)

	if (error) {
		throw new Error('Failed to fetch data', error)
	}

	return data
}

export async function getStudentDayData(scheduleId, studentId) {
	const { data, error } = await supabase.from('scheduledays').select().eq('scheduleId', scheduleId).eq('studentId', studentId)

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function addData(adata) {
	const { data, error } = await supabase.from('scheduledays').insert(adata).select()

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function updateData(udata) {
	console.log('udata', udata)
	const { data, error } = await supabase.from('scheduledays').update(udata).eq('id', udata.id).select()

	if (error) {
		throw new Error('Failed to fetch data')
	}
	console.log('data', data)
	return data
}

export async function deleteIdData(id) {
	const { data, error } = await supabase.from('scheduledays').delete().eq('id', id)
	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function deleteScheduleIdData(scheduleId) {
	const { data, error } = await supabase.from('scheduledays').delete().eq('scheduleId', scheduleId)
	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}
